import React, { createContext, useState, useContext } from 'react';

// Création du contexte
export const MusicContext = createContext();

// Hook personnalisé pour utiliser le contexte musical
export const useMusic = () => useContext(MusicContext);

// Provider du contexte musical
export const MusicProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoRef, setVideoRef] = useState(null);
  
  // Fonction pour jouer/pauser la vidéo YouTube
  const togglePlay = () => {
    if (videoRef) {
      try {
        if (isPlaying) {
          // Pause la vidéo
          videoRef.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else {
          // Joue la vidéo
          videoRef.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        setIsPlaying(!isPlaying);
      } catch (error) {
        console.error("Erreur lors du contrôle de la vidéo:", error);
      }
    }
  };

  // Valeur du contexte
  const value = {
    isPlaying,
    setIsPlaying,
    videoRef,
    setVideoRef,
    togglePlay
  };

  return (
    <MusicContext.Provider value={value}>
      {children}
    </MusicContext.Provider>
  );
};
